import styled from 'styled-components';

export const Container = styled.div`
grid-area: tbar;
display: grid;
z-index: 1;
height: 50px;
width: 98vw;
margin-left: -13px;
padding: 0px;
background-color: rgba(0, 0, 0, 0.8);
grid-template-columns: 1fr 2fr 1fr;
grid-template-areas: 'logo title right';
color: #ffffff;
justify-items: center;
`

export const LeftSide = styled.div`
  grid-area: logo;
  justify-self: left;
  align-self: center;
  /* width: 100%; */
  padding-left: 20px;
`;

export const Title = styled.h2`
  padding: 2px;
  margin: 0;
`;

export const RightSide = styled.div`
  grid-area: right;
  justify-self: right;
  align-self: center;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  * {
    margin: 0px 5px;
  }
  
`;

export const Middle = styled.div`
  grid-area: title;
  display: flex;
  align-items: center;
  justify-content: center;
`;
